import client from "../../external/open-api";
import { components } from "../../external/schema/order-link-api-schema";
import { mapStringToEnum } from "../../helpers/enum-helper";
import { ApplicationError } from "../../models/errors/application-error";
import { ApplicationSetting } from "../../models/organisation/application-setting";
import { ApplicationSettingKey } from "../../models/organisation/application-setting-key";
import BaseService from "../base-service";
import ISettingService from "./setting-service-interface";

export default class SettingService extends BaseService implements ISettingService {

    async getSetting(key: ApplicationSettingKey): Promise<ApplicationSetting | null> {
        const { data, error } = await this.withRetry(() => client.GET("/v{version}/api/organisation/setting/{key}", {
            params: {
                path: { version: "1", key },
            },
        }));

        if (!data?.success || error) {
            throw new ApplicationError("Failed to fetch setting");
        }

        if (!data?.data) {
            return null;
        }

        return this.mapToSetting(data.data);
    }
    async updateSetting(setting: ApplicationSetting): Promise<ApplicationSetting> {
        const { data, error } = await this.withRetry(() => client.PUT("/v{version}/api/organisation/setting", {
            params: {
                path: { version: "1" },
            },
            body: {
                ...setting
            }
        }));

        if (!data?.data || !data?.success || error) {
            throw new ApplicationError("Failed to fetch setting");
        }

        return this.mapToSetting(data.data);
    }

    async onboardWhatsapp(wbaId: string, phoneNumberId: string, embeddedCode: string) {
        const { data, error } = await this.withRetry(() => client.POST("/v{version}/api/organisation/whatsapp", {
            params: {
                path: { version: "1" },
            },
            body: {
                wbaId,
                phoneNumberId,
                embeddedCode
            }
        }));

        if (!data?.data || !data?.success || error) {
            throw new ApplicationError("Failed to integrate with whatsapp");
        }


    }

    private mapToSetting(object: components["schemas"]["SettingDTO"]): ApplicationSetting {
        return {
            key: mapStringToEnum(ApplicationSettingKey, object.key ?? ""),
            value: object.value ?? ""
        }
    }

}